import { Navigate, createBrowserRouter } from "react-router-dom";
import { lazy } from "react";
import Layout from "../containers/Layout";
import NotFound from "../containers/NotFound";
import Home from "../containers/Home";

const Project = lazy(() => import('../containers/ProjectDetail'));
const LetterBoxd = lazy(() => import('../containers/projects/LetterBoxd'));
const Mural = lazy(() => import('../containers/projects/Mural'));
const Bakstak = lazy(() => import('../containers/projects/Bakstak'));
const BingeRead = lazy(() => import('../containers/projects/BingeRead'));
const Calendar = lazy(() => import('../containers/projects/Calendar'));
const Wireframe = lazy(() => import('../containers/projects/Wireframe'));


const router = createBrowserRouter([
    {
        path: "",
        element: <Layout />,
        children: [
            { path: "", element: <Home /> },
            { path: "project/:link", element: <Project /> },
            { path: "project/letterboxd-case-study", element: <LetterBoxd /> },
            { path: "project/mural", element: <Mural /> },
            { path: "project/bakstak", element: <Bakstak /> },
            { path: "project/binge-read", element: <BingeRead /> },
            { path: "project/calendar", element: <Calendar /> },
            { path: "project/wireframe", element: <Wireframe /> },
            { path: "404", element: <NotFound /> },
            {
                path: "*",
                element: <Navigate to="/404" />,
            }
        ]
    }
]);

export { router };